// Created by Michael Abadi Santoso
// 31 May 2020
// Copyright OKKAMI

import styled from "styled-components";

const Image = styled.img`
  height: 500px;
  width: 100%;
  object-fit: cover;
  margin: auto 0;
`;

const TitleProduct = styled.div`
  margin: auto 0;
  color: gray;
  padding: 16px;
  text-align: center;
  font-size: 16px;
`;

const SubTitleProduct = styled.div`
  margin: auto 0;
  font-weight: normal;
  color: gray;
  padding: 16px;
  text-align: center;
  font-size: 14px;
`;

const MiddleContainer = styled.div`
  position: absolute;
  border-radius: 16px;
  border-style: solid;
  border-width: thin;
  border-color: gray;
  background-color: white;
  width: 300px;
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 16px;
`;

const SubTitlePrice = styled.div`
  margin: auto 0;
  font-weight: bold;
  color: ${props => props.app_home_menu_category ? props.app_home_menu_category : "black"};
  padding: 16px;
  text-align: center;
  font-size: 14px;
`;

export { Image, TitleProduct, SubTitleProduct, MiddleContainer, SubTitlePrice };
